module.exports = __webpack_public_path__ + "static/media/itei.2782f13b.jpg";